import { render, staticRenderFns } from "./TableHS.vue?vue&type=template&id=1ec5b92b&"
import script from "./TableHS.vue?vue&type=script&lang=js&"
export * from "./TableHS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports